/* AIWD client-price gate. The "AI Website Design client" price is for verified clients
   (logged in, customer tag aiwd-client) or when a website build is in the same cart.
   Storefront guard only: a checkout validation function would be needed to block every bypass. */
(function () {
  'use strict';
  var G = window.AIWD_GATE || {};
  var ALLOW_WITH_BUILD = true;
  var BUILDS = ['basic-website', 'business-website', 'online-store-website', 'launch-package', 'grow-package', 'store-package', 'market-authority-turn-key-package', 'starter-launch-mega-package', 'business-growth-mega-package', 'ultimate-presence-mega-package'];
  var CLIENT = /ai website design client/i;
  var hasBuild = false;

  function allowed() { return !!G.verified || (ALLOW_WITH_BUILD && hasBuild); }
  function hasCartCookie() { return /(?:^|;\s*)cart=/.test(document.cookie); }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function buildIn(cart) {
    return cart.items.some(function (i) { return BUILDS.indexOf(i.handle) > -1; });
  }

  /* ---- Planner tool: ignore the self-declared "I am already a client" box ---- */
  function patchPlanner() {
    var A = window.AWP;
    if (!A || typeof A.isClient !== 'function' || A.__gated) return;
    var orig = A.isClient;
    A.isClient = function (plan) {
      if (G.verified) return true;
      var p = {};
      for (var k in plan) { if (Object.prototype.hasOwnProperty.call(plan, k)) p[k] = plan[k]; }
      p.cl = 0;
      return orig.call(A, p);
    };
    A.__gated = true;
    try { window.dispatchEvent(new CustomEvent('awp:change')); } catch (e) {}
  }

  /* ---- Product page / quick add: lock the client option ---- */
  function noteHtml() {
    var login = G.logged ? '' : ' <a href="' + (G.loginUrl || '/account/login') + '">Log in</a> if you are a verified client.';
    return 'AI Website Design client pricing is for verified clients, or when a website build is in your cart.' + login;
  }
  function applyPicker() {
    var ok = allowed();
    document.querySelectorAll('variant-picker, form[action*="/cart/add"]').forEach(function (vp) {
      var radios = vp.querySelectorAll('input[type="radio"]');
      var options = vp.querySelectorAll('select option');
      var found = false, anchor = null;
      radios.forEach(function (r) {
        if (!CLIENT.test(r.value)) return;
        found = true;
        anchor = r.closest('fieldset') || r.closest('label');
        var lab = r.closest('label');
        if (!ok) {
          r.setAttribute('aria-disabled', 'true');
          r.setAttribute('data-aiwd-locked', '1');
          if (lab) { lab.style.opacity = '.55'; lab.title = 'Verified AI Website Design clients only'; }
          if (r.checked) {
            var alt = Array.prototype.filter.call(radios, function (x) { return !CLIENT.test(x.value) && x.name === r.name; })[0];
            if (alt) alt.click();
          }
        } else {
          r.removeAttribute('aria-disabled');
          r.removeAttribute('data-aiwd-locked');
          if (lab) { lab.style.opacity = ''; lab.title = ''; }
        }
      });
      options.forEach(function (o) {
        if (!CLIENT.test(o.value) && !CLIENT.test(o.textContent)) return;
        found = true;
        anchor = o.parentNode;
        o.disabled = !ok;
        if (!ok && o.selected) {
          var sel = o.parentNode;
          var alt = Array.prototype.filter.call(sel.options, function (x) { return !CLIENT.test(x.value) && !CLIENT.test(x.textContent); })[0];
          if (alt) { sel.value = alt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      });
      var n = vp.querySelector('.aiwd-gate-note');
      if (found && !ok) {
        if (!n) {
          n = document.createElement('p');
          n.className = 'aiwd-gate-note';
          n.setAttribute('role', 'note');
          n.style.cssText = 'margin:8px 0 0;font-size:14px;line-height:1.5;color:#3A4B5E';
          n.innerHTML = noteHtml();
          if (anchor && anchor.insertAdjacentElement) anchor.insertAdjacentElement('afterend', n); else vp.appendChild(n);
        }
      } else if (n) { n.remove(); }
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var inp = t && t.closest ? (t.matches('input[data-aiwd-locked]') ? t : (t.closest('label') && t.closest('label').querySelector('input[data-aiwd-locked]'))) : null;
    if (inp && !allowed()) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* ---- Cart guard: swap client-price lines to the New client price when not allowed ---- */
  var busy = false, timer = null;
  function enforce() {
    if (busy || G.verified || !hasCartCookie()) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      hasBuild = buildIn(cart);
      applyPicker();
      if (allowed()) return;
      var bad = cart.items.filter(function (i) { return CLIENT.test(i.variant_title || ''); });
      if (!bad.length) return;
      return bad.reduce(function (p, item) {
        return p.then(function () {
          return fetch('/products/' + item.handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (prod) {
            var tgt = prod.variants.filter(function (v) { return !CLIENT.test(v.title) && /new client/i.test(v.title); })[0];
            return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 0 }) }).then(function () {
              if (!tgt) return;
              var line = { id: tgt.id, quantity: item.quantity };
              if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) line.selling_plan = item.selling_plan_allocation.selling_plan.id;
              if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
              return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [line] }) });
            });
          });
        });
      }, Promise.resolve()).then(function () {
        var last = Number(sessionStorage.getItem('aiwdGateReload') || 0);
        sessionStorage.setItem('aiwdGateReload', String(Date.now()));
        sessionStorage.setItem('aiwdGateMsg', '1');
        if (Date.now() - last > 6000) location.reload();
      });
    }).catch(function () {}).then(function () { busy = false; });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(enforce, 900); }

  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u) && u.indexOf('aiwdGate') < 0) { p.then(schedule, function () {}); }
      return p;
    };
  }

  function banner() {
    if (sessionStorage.getItem('aiwdGateMsg') !== '1') return;
    sessionStorage.removeItem('aiwdGateMsg');
    var d = document.createElement('div');
    d.setAttribute('role', 'status');
    d.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:76px;z-index:99999;max-width:92vw;background:#0D1B2A;color:#fff;padding:12px 16px;border-radius:12px;font-size:15px;line-height:1.45;box-shadow:0 6px 24px rgba(0,0,0,.25)';
    d.textContent = 'An item was switched to the New client price. The AI Website Design client price is for verified clients, or when a website build is in your cart.';
    document.body.appendChild(d);
    setTimeout(function () { d.remove(); }, 9000);
  }

  function boot() {
    patchPlanner();
    banner();
    applyPicker();
    if (hasCartCookie() && !G.verified) {
      getCart().then(function (c) { hasBuild = buildIn(c); applyPicker(); return enforce(); }).catch(function () {});
    }
    new MutationObserver(function () { applyPicker(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', patchPlanner);
})();
